import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { Response } from "@angular/http";
import { HttpClient } from "@angular/common/http";
import * as _ from "lodash";

@Injectable()
export class OrderService {
  public order = new Array();
  public orderSource = new BehaviorSubject(null);

  public orderPricingSource = new BehaviorSubject(null);
  public orderPricing;

  public orderLength = new BehaviorSubject(null);

  public locationID = new BehaviorSubject(null);

  // These are for opening a ticket
  public employeeID = new BehaviorSubject(null);
  public tableID = new BehaviorSubject(null);
  public revenueCenterID = new BehaviorSubject(null);
  public orderType = new BehaviorSubject(null);
  public ticketID = new BehaviorSubject(null);
  public ticket = new BehaviorSubject(null);

  constructor(private _http: HttpClient) {
    if (localStorage.getItem("order")) {
      const storageOrder = JSON.parse(localStorage.getItem("order"));
      storageOrder.forEach((item, index) => {
        if (index !== storageOrder.length) {
          this.updateOrder(item);
        }
      });
    }
  }

  public getOrder() {
    return this.orderSource.asObservable();
  }

  public getOrderLength() {
    return this.orderLength.asObservable();
  }

  public getOrderType() {
    return this.orderType.asObservable();
  }

  public getEmployeeID() {
    return this.employeeID.asObservable();
  }

  public getTableID() {
    return this.tableID.asObservable();
  }

  public getRevenueCenterID() {
    return this.revenueCenterID.asObservable();
  }

  public getLocationID() {
    return this.locationID.asObservable();
  }

  public getTicketID() {
    return this.ticketID.asObservable();
  }

  public getTicket() {
    return this.ticket.asObservable();
  }

  public getPricingObj() {
    if (!this.orderPricing && localStorage.getItem("orderPricing")) {
      this.orderPricing = JSON.parse(localStorage.getItem("orderPricing"));
      return this.orderPricing.asObservable();
    } else if (!this.orderPricing && !localStorage.getItem("orderPricing")) {
      return this.orderPricing.asObservable(0);
    }
  }
  /**
   * Takes in an item and updates the order.
   * @param {item} Object
   */
  public updateOrder(item) {
    if (item === null) {
      this.orderSource.next([]);
    } else {
      // Add the item to the order
      this.order.push(item);

      // Update the order observable for all components subscribed
      this.orderSource.next(this.order);

      // Updates the order length
      this.updateOrderLength();
      console.log("order-source:", this.orderSource);

      // Updates the pricing for the order
      this.calculatePricing(this.order);
      console.log("order", this.order);

      // Attatch the order to local storage
      localStorage.setItem("order", JSON.stringify(this.order));
    }
  }

  /**
   * Updates the item quantity in the current order.
   * @param {itemID} string
   * @param {quantity} number
   * @param {index} number
   */
  public updateItemQuantity(itemID, quantity, index) {
    for (let i = 0; this.order.length > i; i++) {
      if (i === index) {
        this.order[i].quantity = quantity;
        console.log(this.order[i]);
      }
    }
    // Update the pricing based on the new quantity
    this.calculatePricing(this.order);
    // Update the order length based on the new quantity
    this.updateOrderLength();
    // Update the order based on the new quantity
    this.orderSource.next(this.order);
  }

  /**
   * Updates the ticket ID Observable
   * @param {id} string
   * @return {formatted price} string
   */
  public updateTicketID(id) {
    sessionStorage.setItem("ticketID", id);
    this.ticketID.next(id);
  }
  /**
   * Updates the order length Observable based on the item quantities
   */
  private updateOrderLength() {
    let newOrderLength = 0;
    for (let i = 0; this.order.length > i; i++) {
      newOrderLength += this.order[i].quantity;
    }
    this.orderLength.next(newOrderLength);
  }

  /**
   * Updates the ticket observable
   */
  public updateTicket(ticket) {
    this.ticket.next(ticket);
  }

  /**
    * Calculates the pricing for an order
    @param {order} Array
*/
  public calculatePricing(order) {
    let orderSubTotal: number = 0;
    let orderTax: number = 0;
    let orderTotal: number = 0;

    // Loop through the order and get the price for each item
    for (let i = 0; i < order.length; i++) {
      let itemPrice = parseFloat(order[i].formatted_price);
      // Multiply the price by the quantity of the item
      itemPrice *= order[i].quantity;
      console.log(itemPrice);
      orderSubTotal += itemPrice;
      console.log("item", order[i]);

      // Loop through the modifiers of the item in the order
      if (order[i].modifiers.length > 0) {
        for (let j = 0; j < order[i].modifiers.length; j++) {
          let modifier = order[i].modifiers[j];

          // Get the price of the modifier
          let modifierPrice = parseFloat(modifier.formatted_price);

          // Check if the modifier price is a number (Some modifiers don't have a price)
          if (!isNaN(modifierPrice)) {
            modifierPrice *= order[i].quantity;
            orderSubTotal += modifierPrice;
          }
        }
      }
    }
    orderTax = orderSubTotal * 0.08;
    orderTotal = orderSubTotal + orderTax;
    let pricingObj = {
      tax: orderTax.toFixed(2),
      total: orderTotal.toFixed(2),
      subTotal: orderSubTotal.toFixed(2)
    };
    // Update the pricing object observable
    this.orderPricingSource.next(pricingObj);
    // Update the local storage
    localStorage.setItem("pricingObject", JSON.stringify(pricingObj));
  }

  /**
    * Removes an item from the current Order
    @param {itemID} string
*/
  public removeItemFromOrder(itemID) {
    for (let i = 0; i < this.order.length; i++) {
      if (this.order[i].menu_item === itemID) {
        this.order.splice(i, 1);
        // Update the order observable
        this.orderSource.next(this.order);
      }
    }
    // Re-calculate the pricing
    this.calculatePricing(this.order);
    // Re-assign the order length
    this.orderLength.next(this.order.length);
  }

  public updateLocationID(id) {
    this.locationID.next(id);
    localStorage.setItem("locationID", id);
  }

  public openTicket(ticketData, locationID) {
    return this._http
      .post("/api/orders/open", {
        ticketData: ticketData,
        locationID: locationID
      })
      .map((response: Response) => response)
      .catch(this.handleError);
  }

  public addItemsToTicket(locationID, ticketID, order) {
    console.log("service", ticketID);
    console.log("ORDER", order);
    return this._http
      .post("/api/orders/add/items", {
        locationID: locationID,
        ticketID: ticketID,
        order: order
      })
      .map((response: Response) => response)
      .catch(this.handleError);
  }

  public getTicketByID(ticketID, locationID) {
    return this._http
      .get("/api/orders/", { params: { ticketID: ticketID, locationID } })
      .map((response: Response) => response)
      .catch(this.handleError);
  }

  public getItemModifiers(url) {
    return this._http
      .get("/api/orders/item/modifiers", { params: { url: url } })
      .map((response: Response) => response)
      .toPromise()
      .catch(this.handleError);
  }

  public clearOrderAndTicket() {
    this.order = [];
    localStorage.removeItem("order");
    sessionStorage.removeItem("order");
    this.orderSource.next(null);
    this.ticketID.next(null);
    this.ticket.next(null);
    this.orderPricingSource.next(null);
    this.orderLength.next(null);
    console.log("orderSource:", this.orderSource);
  }

  getEmployeeByID(locationID) {
    return this._http
      .get("/api/employees", { params: { locationID: locationID } })
      .map((response: Response) => response)
      .catch(this.handleError);
  }

  private handleError(error) {
    console.error(error);
    if (error.status == 404) {
      // alert('Please change all references to /confidential/fixture/work.json to /fixture/work.json in the work.service.ts file');
    }
    return Observable.throw(error.json().error || "Server error");
  }
}



// WEBPACK FOOTER //
// ./src/app/services/order/order.service.ts